import React from 'react'
import { change, show, store, update, error as changeError, success as changeSuccess } from '../../../store/actions/account.action'
import { CircularProgress, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TextField, AppBar, Toolbar, IconButton, Typography, Button, Dialog, FormGroup, Checkbox } from '@material-ui/core'
import { FaSave } from 'react-icons/fa'
import { MdClose, MdContentCopy, MdKeyboardBackspace } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux'
import { changeScreen } from '../../../store/actions/navigation.action'
import { changeNotify } from '../../../store/actions/notify.action'
import { rootUrl } from '../../../config/App'
import { Pagstar, Pay2m, Ezzy, Fluxsis, Infrapay, Infopago, CodePay, Suitpay, Paggue, Mercadopago, EfiPay, Avexpay, Paysure } from '../../components/banks'


const GATEWAYS = {
    pay2m:       { require_cpf: false, require_email: false, label: 'PAY2M',        bankClass: 'bank pay2m',          badgeClass: 'badge-pay2m',       Component: Pay2m },
    paysure:     { require_cpf: false, require_email: false, label: 'PAYSURE',      bankClass: 'bank paysure',        badgeClass: 'badge-paysure',     Component: Paysure },
    avexpay:     { require_cpf: true,  require_email: true,  label: 'AVEXPAY',      bankClass: 'bank avexpay',        badgeClass: 'badge-avexpay',     Component: Avexpay },
    codepay:     { require_cpf: false, require_email: false, label: 'CODE PAY',     bankClass: 'bank codepay',        badgeClass: 'badge-codepay',     Component: CodePay },
    efipay:      { require_cpf: true,  require_email: false, label: 'EFI BANK',     bankClass: 'bank efipay',         badgeClass: 'badge-efipay',      Component: EfiPay },
    ezzy:        { require_cpf: false, require_email: false, label: 'EZZY BANK',    bankClass: 'bank ezzy d-none',    badgeClass: 'badge-ezzy',        Component: Ezzy },
    fluxsis:     { require_cpf: true,  require_email: true,  label: 'FLUXSIS',      bankClass: 'bank fluxsis d-none', badgeClass: 'badge-fluxsis',     Component: Fluxsis, disabled: true },
    infrapay:    { require_cpf: true,  require_email: true,  label: 'INFRAPAY',     bankClass: 'bank infrapay',       badgeClass: 'badge-infrapay',    Component: Infrapay },
    infopago:    { require_cpf: true,  require_email: true,  label: 'INFOPAGO',     bankClass: 'bank infopago',       badgeClass: 'badge-infopago',    Component: Infopago, onlyCapitalizer: true },
    //paggue:    { require_cpf: true,  require_email: true,  label: 'PAGGUE',       bankClass: 'bank paggue',         badgeClass: 'badge-paggue',      Component: Paggue },
    pagstar:     { require_cpf: true,  require_email: true,  label: 'PAGSTAR',      bankClass: 'bank pagstar',        badgeClass: 'badge-pagstar',     Component: Pagstar, onlyCapitalizer: true },
    suitpay:     { require_cpf: true,  require_email: true,  label: 'SUIT PAY',     bankClass: 'bank suitpay',        badgeClass: 'badge-suitpay',     Component: Suitpay },
    mercadopago: { require_cpf: true,  require_email: true,  label: 'MERCADO PAGO', bankClass: 'bank mercadopago',    badgeClass: 'badge-mercadopago', Component: Mercadopago },
}

function GatewayFields({ gateway, id }) {
    if (!gateway) return null

    const GatewayComponent = GATEWAYS[gateway]?.Component

    if (!GatewayComponent) return null

    return <GatewayComponent id={id} />
}

export default function AccountEdit(props) {
    const dispatch = useDispatch()
    const { app } = useSelector(state => state.appReducer)
    const { account, error } = useSelector(state => state.accountReducer)
    const id = (props.uid) ? props.uid : null
    const gateway = (props.gateway) ? props.gateway : null

    const [isLoading, setLoading] = React.useState(true)
    const [isModal, setModal] = React.useState(false)
    const [rate, setRate] = React.useState(null)

    React.useEffect(() => {
        _index()
        return () => {
            dispatch(change('clear'))
            dispatch(changeSuccess(false))
            dispatch(changeError({}))
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    React.useEffect(() => {
        if(account.gateway === 'pagstar' || account.gateway === 'infopago') {
            setRate(account.rate)
            dispatch(change({rate: 'total'}))
        }else {
            dispatch(change({rate: rate ? rate : account.rate}))
        }

    }, [account.gateway])

    React.useEffect(() => {
		var clipboard = new window.ClipboardJS('.copy-webhook')

		clipboard.on('success', function(e) {
			dispatch(changeNotify({
                open: true,
                msg: 'Webhook copiado com sucesso',
                class: 'success'
            }))
		})

        return () => clipboard.destroy()
	},[])

    const _index = () => {
        if (id) {
            dispatch(show(id)).then(res => res && setLoading(false))
        } else {
            dispatch(change({ gateway: gateway }))
            setLoading(false)
        }
    }

    const _save = () => {
        if(id) {
            dispatch(update(id, account))
        } else {
            dispatch(store(account))
        }
    }

    const availableGateways = React.useMemo(() => {
        return Object.entries(GATEWAYS)
            .filter(([, g]) => !g.onlyCapitalizer || app.capitalizer)
            .map(([value, g]) => ({ value, ...g }))
    }, [app.capitalizer])

    return (
        <>

            <div className="app-bar">
                <AppBar position="fixed">
                    <Toolbar>
                        <IconButton onClick={() => dispatch(changeScreen({ open: false }))} edge="start" color="inherit">
                            <MdKeyboardBackspace />
                        </IconButton>
                        <Typography variant="h6">
                            {(id) ? 'Editar Gateway' : 'Novo Gateway'}
                        </Typography>

                        <Button 
                            variant="contained" 
                            size="small"
                            onClick={() => _save()}
                            color="inherit" 
                            className="ms-auto btn-app-bar"
                            startIcon={<FaSave />}
                        >
                            Salvar
                        </Button>
                    </Toolbar>
                </AppBar>

                {(isLoading) ? <div className="d-flex justify-content-center mt-5 pt-5"> <CircularProgress /> </div> :
                <>
                    <Dialog
                        open={isModal}
                        maxWidth="sm"
                        style={{width: '100%'}}
                        onClose={() => setModal(false)}
                        className="center"
                    >       
                        <div className="d-flex justify-content-end">
                            <IconButton
                                onClick={() => setModal(false) }
                            >
                                <MdClose />
                            </IconButton>
                        </div>
                        <video className="help-video" controls>
                            <source src={rootUrl+'/fluxsis.mov'} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </Dialog>

                    <div className="card card-body mt-3 bs-bg">
                        <div className="mb-3">
                            <div className="d-flex justify-content-between">
                                <div className="d-flex flex-column">
                                    <label className="label-custom m-0 bs-color-b">Banco</label>
                                    <div className="mt-2 d-flex align-items-center">
                                        {account.gateway &&
                                            <button className="fw-bold btn-bank h6">
                                                {GATEWAYS[account.gateway] && (
                                                    <small className={`badge ${GATEWAYS[account.gateway].badgeClass}`}>
                                                        {GATEWAYS[account.gateway].label}
                                                    </small>
                                                )}
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr className="hr-muted"/>

                        <div className="mb-3">
                            <FormControl component="fieldset">
                                <FormLabel className="bs-color" component="legend">Taxas</FormLabel>
                                <RadioGroup
                                    aria-label="gender" 
                                    name="gender1" 
                                    value={account.rate || ''} 
                                    onChange={ e => dispatch(change({rate: e.target.value}))}
                                    className="fw-normal bs-color-b"
                                >
                                    <FormControlLabel disabled={(account.gateway === 'pagstar' || account.gateway === 'infopago')} value="parcial" control={<Radio color="primary" />} label="Parcial Cliente" />
                                    <FormControlLabel value="total" control={<Radio color="primary" />} label="Assumir Taxa" />
                                </RadioGroup>
                            </FormControl>
                        </div>

                        <div className="mb-3 mt-1">
                            <FormControl component="fieldset">
                                <FormLabel className="bs-color" component="legend">Campos Obrigatórios</FormLabel>
                                
                                <FormGroup className="fw-normal bs-color-b account-required">
                                    <FormControlLabel 
                                        value={account.require_cpf} 
                                        control={
                                            <Checkbox 
                                                checked={account.require_cpf} 
                                                disabled={GATEWAYS[account.gateway].require_cpf} 
                                                color="primary" 
                                                name="cpf"
                                                onChange={e => dispatch(change({require_cpf: e.target.checked}))}
                                            />} 
                                        label="CPF" 
                                    />
                                    <FormControlLabel 
                                        value={account.require_email}
                                        control={
                                            <Checkbox 
                                                checked={account.require_email} 
                                                disabled={GATEWAYS[account.gateway].require_email} 
                                                color="primary" 
                                                name="email"
                                                onChange={e => dispatch(change({require_email: e.target.checked}))}
                                            />} 
                                        label="Email" 
                                    />
                                </FormGroup>
                            </FormControl>
                        </div>
                    </div>

                    <div className="card card-body mt-3 bs-bg">
                        {account.gateway &&
                            <div className="mb-3">
                                <label className="label-custom bs-color-b">Descrição da Conta</label>
                                <TextField
                                    error={(error.title) && true}
                                    value={account.title || ''}
                                    placeholder={account.gateway ? 'Ex: '+account.gateway+' Pedro' : 'Ex: '}
                                    onChange={e => {
                                        dispatch(change({title: e.target.value}))
                                        if (error.title && delete error.title);
                                    }}
                                />

                                {(error.title) &&
                                    <strong className="text-danger">{error.title[0]}</strong>
                                }
                            </div>
                        }

                        {(account.gateway === 'codepay') && 
                            <>
                                {id && 
                                    <>
                                    <div className="d-flex align-items-center">
                                        <label className="label-custom m-0 bs-color-b">WEBHOOK</label>
                                        <IconButton className='copy-webhook bs-color' data-clipboard-target={"#copy-webhook"}>
                                            <MdContentCopy />
                                        </IconButton>
                                    </div>
                                    <TextField
                                        id="copy-webhook"
                                        value={account.codepay_webhook || ''}
                                    />
                                    </>
                                }
                            </>
                        }

                        {!id && 
                            <GatewayFields
                                id={id}
                                gateway={account.gateway}
                            />
                        }
                    </div>
                </>
                }
            </div>
        </>
    )
}